export default "__VITE_ASSET__DpsLLQEP__"